import { useState } from "react";
import { ConfirmatableDialog } from "ui/molecules/Dialog";
import { ReviewableAction, useActionContext } from "../../providers";
import type { DialogProps } from "./types";

const Approve = ({ renderLabel, onConfirm }: DialogProps) => {
    const [isProcessing, setProcessing] = useState(false);

    const { hasAction, reset } = useActionContext();

    const close = () => reset(ReviewableAction.Approve);

    const handleConfirm = async () => {
        setProcessing(true);

        try {
            await onConfirm();
            close();
        } finally {
            setProcessing(false);
        }
    };

    const content = {
        dialogContent: [
            `Are you sure that you would like to approve ${renderLabel()}?`
        ],
        actionContent: 'approve'
    };

    return (
        <ConfirmatableDialog
            isProcessing={isProcessing}
            open={hasAction(ReviewableAction.Approve)}
            checkPredicate={() => false}
            content={[
                content,
                content
            ]}
            onConfirm={handleConfirm}
            onCancel={close}
        />
    );
};

export default Approve;
